import { all, fork } from 'redux-saga/effects';
import bank from 'src/redux/sagas/bankSaga';
import catalog from 'src/redux/sagas/catalogSaga';
import category from 'src/redux/sagas/categorySaga';
import deal from 'src/redux/sagas/dealSaga';
import deposit from 'src/redux/sagas/depositSaga';
import location from 'src/redux/sagas/locationSaga';
import notification from 'src/redux/sagas/notificationSaga';
import profile from 'src/redux/sagas/profileSaga';
import referral from 'src/redux/sagas/referralSaga';
import saleOrder from 'src/redux/sagas/saleOrderSaga';
import tracking from 'src/redux/sagas/trackingSaga';
import user from 'src/redux/sagas/userSaga';
import vnTracking from 'src/redux/sagas/vnTrackingSaga';
import website from 'src/redux/sagas/websiteSaga';
import debtRecovery from 'src/redux/sagas/debtRecovery';
import checkPriceProduct from 'src/redux/sagas/checkPriceProductSaga';

export default function* root() {
  yield all([
    fork(bank),
    fork(catalog),
    fork(category),
    fork(deal),
    fork(deposit),
    fork(location),
    fork(notification),
    fork(profile),
    fork(referral),
    fork(saleOrder),
    fork(tracking),
    fork(user),
    fork(vnTracking),
    fork(website),
    fork(debtRecovery),
    fork(checkPriceProduct)
  ]);
}
